<!-- 盘点历史 -->

<template>
  <div class="put-with-draw">
    <div class="panle now-money-info">
      <div class="now-money">
        <span class="tit">当前可提现金额</span>
        <span class="money">￥{{ data.amount.toFixed(2) }}</span>
      </div>
    </div>
    <div class="panle withdraw-box">
      <div class="withdraw">
        <span class="tit">请输入提现金额</span>
        <div class="put-money">
          <input type="text" v-model="amount" placeholder="请输入提现金额" />
        </div>
        <!-- <div class="item phone">
          <input type="text" v-model="phone" placeholder="请填写正确的手机号" />
        </div> -->
        <div class="item code">
          <input type="text" v-model="code" placeholder="请填写验证码" />
        </div>
        <span class="get-code" v-if="!isGetCode" @click="getCode">立即获取</span>
        <span class="sendCode" v-if="isGetCode">{{ time + ' s' }}</span>
        <div class="put">
          <button @click="withdraw">提现</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { url } from "@/router/url.js";
import { BASE_URL, API_BASE_URL } from "./../../../../urlConfig/index";
export default {
  props: ["curStoreId", "pageSize"],
  data() {
    return {
      allAmount: 0, //总金额
      allQty: 0, //总数量
      withdrawData: [],
      getBtn: true, // 控制翻页请求
      size: 10,
      totalElements: 0,
      data: {
        amount: 0
      },
      canClick: true,
      amount: 0,
      isShowCodeTip: false, // 是否显示验证嘛提示
      isGetCode: false, // 是否获取验证码
      time: 60,
      phone: "", // 手机号
      code: "", // 验证码
      info: []
    };
  },
  methods: {
    getCode: function () {
      // this.phone = this.phone.replace(/\s+/g, "");
      if (!this.data.username) {
        this.$message({
          message: "请检查设置提现信息页面手机号是否有误",
          customClass: "error"
        });
        return;
      }
      if (/^1[3|4|5|6|7|8|9][0-9]{9}$/.test(this.data.username)) {
        this.isGetCode = true;
        this.$http
          .post(
            API_BASE_URL + "v1/verify-code?mobile=" +
            this.data.username +
            "&type=ACCOUNT"
          )
          .then(res => {
            this.isShowCodeTip = true;
            let intervalCode = setInterval(() => {
              this.time--;
              if (this.time <= 0) {
                this.isGetCode = false;
                this.isShowCodeTip = false;
                this.time = 60;
                clearInterval(intervalCode);
              }
            }, 1000);
          })
          .catch(err => {
            this.isGetCode = false;
            this.isShowCodeTip = false;
          });
      } else {
        this.$message({
          message: "请输入正确的手机号",
          customClass: "error"
        });
        return;
      }
    },
    getWithdrawData(storeId, page) {
      this.$http({
        url: "get-withdraw",
        method: "GET",
        params: {
          storeId,
          page,
          size: this.size
        }
      }).then(res => {
        console.log(res);
        if (res.status == 200) {
          this.withdrawData = res.data.content;
          this.totalElements = res.data.totalElements;
        }
      });
    },
    getInfo() {
      this.$http({
        url: "get-account",
        method: "GET",
        params: {
          storeId: this.curStoreId
        }
      }).then(res => {
        this.data = res.data;
        console.log(res.data);
        if (res.data.username == "") {
          this.$message({
            message: "请先填写提现资料",
            customClass: "error"
          });
          this.$router.push(`/sys/${this.$route.params.id}/setWithdraw`);
        }
      });
    },
    withdraw() {
      if (this.data.amount <= 100 || this.amount <= 100) {
        this.$message({
          message: "提现金额小于100，暂不能提现。",
          customClass: "error"
        });
        return;
      }
      if (!/\d/.test(this.amount)) {
        this.$message({
          message: "金额填写错误",
          customClass: "error"
        });
        return;
      }
      if (this.amount <= 0) {
        this.$message({
          message: "金额必须大于0",
          customClass: "error"
        });
        return;
      }
      if (!this.canClick) {
        return;
      }
      this.canClick = false;
      this.$http({
        url: "put-withdraw",
        method: "POST",
        data: {
          storeId: this.curStoreId,
          amount: this.amount,
          userName: this.data.username,
          accountPayee: this.data.accountPayee,
          accountPeople: this.data.accountPeople,
          verCode: this.code
        }
      }).then(res => {
        setTimeout(() => {
          this.canClick = true;
        }, 500);
        console.log(res.data);
        if (res.data.result.code == 200) {
          this.$message({
            message: res.data.result.msg,
            customClass: "success"
          });
          this.getInfo();
        } else if (res.data.result.code == 400) {
          this.$message({
            message: res.data.result.msg,
            customClass: "error"
          });
        }
      }).catch(err => {
        setTimeout(() => {
          this.canClick = true;
        }, 500);
      });
    }
  },
  activated: function () {
    this.getInfo();
  }
};
</script>
<style lang="scss" scoped>
@import "../../../../../static/css/common.scss";
@import "../../../tableTemplate/tableTem.scss";
@import "./putWithdraw.scss";
</style>



// WEBPACK FOOTER //
// putWithdraw.vue?1ecfb084